import { styled } from '@mui/material/styles';
import { withDatagridStickyStyles } from 'shared/react-admin/Datagrids/DatagridSticky/withDatagridStickyStyles';
import { DatagridWithStickyActions } from 'shared/react-admin/Datagrids/DatagridWithStickyActions/DatagridWithStickyActions';
import { getColumnStyle } from 'utils';

const StickyDatagridWithStickyActions = withDatagridStickyStyles(DatagridWithStickyActions);

export const DatagridStyled = styled(StickyDatagridWithStickyActions)({
  '& .RaDatagrid-headerCell': {
    verticalAlign: 'middle',
    padding: '10px 16px',
    lineHeight: '18px',
  },
  '& .RaDatagrid-rowCell': {
    verticalAlign: 'middle',
    padding: '10px 16px',
  },
  '& .MuiTableSortLabel-root': {
    alignItems: 'center',
  },
  '& td.MuiTableCell-paddingCheckbox': {
    padding: '13px 16px',
    verticalAlign: 'middle',
  },
  '& th.MuiTableCell-paddingCheckbox': {
    padding: '13px 16px',
    verticalAlign: 'middle',
  },
  '& .RaBulkActionsToolbar-toolbar:first-of-type': {
    height: '56px',
  },
  '& .RaBulkActionsToolbar-collapsed:first-of-type': {
    height: '0',
    display: 'flex',
    alignItems: 'center',
    paddingTop: '0',
  },
  '& .RaBulkActionsToolbar-title': {
    alignItems: 'center',
  },
  '& .column-enabled': {
    textAlign: 'center',
  },
  '& .column-corporateEmail ': getColumnStyle(142),
});
